var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegistrationDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1094 46.25H41.3281V6.17188L35.1562 0H4.76562V3.75H1.01562V50H37.1094V46.25ZM35.4688 1.95312L39.375 5.85938H35.4688V1.95312ZM5.9375 1.17188H34.375V7.03125H40.2344V45.1562H5.9375V1.17188ZM2.1875 48.8281V4.84375H4.76562V46.25H36.0156V48.8281H2.1875Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2031 26.6406H9.375V27.8125H33.2031V26.6406Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9219 17.7344H9.375V18.9062H34.9219V17.7344Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5625 35.5469H9.375V36.7188H36.5625V35.5469Z",
    fill: "#666666"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281 8.82812H9.375V10H28.8281V8.82812Z",
    fill: "#666666"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5625 13.9844L44.1406 18.8281V43.8281C44.1406 45.1562 45.2344 46.25 46.5625 46.25C47.8906 46.25 48.9844 45.1562 48.9844 43.8281V18.8281L46.5625 13.9844ZM46.5625 16.5625L47.8125 19.1406V20.3906H45.3125V19.1406L46.5625 16.5625ZM47.8125 21.4844V40.5469H45.3125V21.4844H47.8125ZM46.5625 45.1563C45.8594 45.1563 45.3125 44.6094 45.3125 43.9063V41.7188H47.8906V43.9063C47.8125 44.5313 47.2656 45.1563 46.5625 45.1563Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationDate);
export default __webpack_public_path__ + "static/media/registrationDate.6bb0c90b1a21e6334f843f953efe8f05.svg";
export { ForwardRef as ReactComponent };